export default __webpack_public_path__ + "static/media/facial_35.df1be785.jpg";